const CUSTOM_ELEMENT_ID = "banner-logoanimation";
const DESKTOP_MEDIA_QUERY = "(min-width: 1024px)";

class BannerLogoanimation extends HTMLElement {

    constructor() {
        super();
        this.desktopVideos = [];
        this.mobileVideos = [];
        this.desktopMediaQuery = null;
        this.handleViewportChange = this.handleViewportChange.bind(this);
        this.handleVideoEnded = this.handleVideoEnded.bind(this);
    }

    connectedCallback() {
        this.desktopVideos = Array.from(this.querySelectorAll('.desktop-videos .videoplayer'));
        this.mobileVideos = Array.from(this.querySelectorAll('.mobile-video .videoplayer'));

        this.allVideos().forEach(video => {
            video.addEventListener('ended', this.handleVideoEnded);
        });

        this.desktopMediaQuery = window.matchMedia(DESKTOP_MEDIA_QUERY);
        this.desktopMediaQuery.addEventListener('change', this.handleViewportChange);

        this.playActiveVideos();
    }

    disconnectedCallback() {
        this.allVideos().forEach(video => {
            video.removeEventListener('ended', this.handleVideoEnded);
        });
        if (this.desktopMediaQuery) {
            this.desktopMediaQuery.removeEventListener('change', this.handleViewportChange);
        }
    }

    allVideos() {
        return [...this.desktopVideos, ...this.mobileVideos];
    }

    // Nur die zum aktuellen Viewport passenden Videos laden und abspielen
    playActiveVideos() {
        const isDesktop = this.desktopMediaQuery.matches;
        const activeVideos = isDesktop ? this.desktopVideos : this.mobileVideos;
        const inactiveVideos = isDesktop ? this.mobileVideos : this.desktopVideos;

        inactiveVideos.forEach(video => video.pause());
        activeVideos.forEach(video => this.startVideo(video));
    }

    startVideo(video) {
        video.currentTime = 0;
        const playPromise = video.play();
        if (playPromise !== undefined) {
            playPromise.catch(error => {
                console.log('Video autoplay verhindert:', error);
            });
        }
    }

    handleViewportChange() {
        this.playActiveVideos();
    }

    handleVideoEnded(event) {
        event.target.pause();
    }
}

if (!customElements.get(CUSTOM_ELEMENT_ID)) {
    customElements.define(CUSTOM_ELEMENT_ID, BannerLogoanimation);
}
